import React from 'react';

import FAQAccordionItem from './AccordionItem';

const FAQ = ({ entity, className, viewMode, ...props }) => {

  return <FAQAccordionItem entity={entity} {...props} />;
};

export default FAQ;
